import { render } from "./HomePage.vue?vue&type=template&id=6c6ec916&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=6c6ec916&scoped=true&lang=css"

import exportComponent from "/Users/josecisneros/Desktop/Jose-Cisneros/Portfolio-Site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6ec916"]])

export default __exports__